import { cancelBuild } from '@/api/builds';
import { Button } from '@/components/ui/button';
import { Spinner } from '@/components/ui/spinner';
import type { IBuild } from '@/entities/build.entity';
import { useState } from 'react';
import { toast } from 'sonner';

interface BuildCancelButtonProps {
	build: IBuild;
	onCancelled?: () => void;
	variant?: 'default' | 'outline' | 'destructive' | 'ghost';
	size?: 'default' | 'sm';
	className?: string;
}

export default function BuildCancelButton({
	build,
	onCancelled,
	variant = 'outline',
	size = 'sm',
	className,
}: BuildCancelButtonProps) {
	const [loading, setLoading] = useState(false);

	async function handleCancel() {
		setLoading(true);
		const isStale = build.progressStatus === 'stale';
		try {
			await cancelBuild(build.id);
			toast.success(isStale ? 'Статус билда сброшен' : 'Билд отменён');
			await onCancelled?.();
		} catch {
			// error toast handled by api interceptor
		} finally {
			setLoading(false);
		}
	}

	return (
		<Button
			type='button'
			variant={variant}
			size={size}
			className={className}
			disabled={loading}
			onClick={() => void handleCancel()}
		>
			{loading ? <Spinner className='size-4' /> : build.progressStatus === 'stale' ? 'Сбросить' : 'Отменить'}
		</Button>
	);
}
